import { Download, Share2, FileText } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@shared/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetDescription,
  SheetFrame,
} from '@shared/components/ui/sheet';
import type { Receipt } from '../../types/panel-common.types';

interface ReceiptDetailSheetProps {
  open: boolean;
  receipt: Receipt;
  onClose: () => void;
}

export function ReceiptDetailSheet({ open, receipt, onClose }: ReceiptDetailSheetProps) {
  return (
    <Sheet open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <SheetContent className="overflow-hidden flex flex-col">
        <div className="mb-6">
          <SheetTitle>{receipt.name}</SheetTitle>
          <SheetDescription>{receipt.timestamp}</SheetDescription>
        </div>

        <SheetFrame className="flex-1">
          <div className="h-full overflow-y-auto p-6 space-y-6">
            {/* Document preview placeholder */}
            <div className="flex flex-col items-center justify-center h-48 bg-muted/30 rounded-xl border border-dashed border-border">
              <FileText className="h-10 w-10 text-muted-foreground mb-3" />
              <p className="text-sm font-medium text-foreground text-center px-4 truncate max-w-full">
                {receipt.name}
              </p>
              <p className="text-xs text-muted-foreground mt-1">{receipt.timestamp}</p>
            </div>

            {/* Details */}
            <div className="space-y-0">
              <div className="flex justify-between items-center py-3 border-b border-border">
                <span className="text-sm text-muted-foreground">Document</span>
                <span className="text-sm text-foreground font-medium">{receipt.name}</span>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-border">
                <span className="text-sm text-muted-foreground">Date</span>
                <span className="text-sm text-foreground">{receipt.timestamp}</span>
              </div>
            </div>

            {/* Actions */}
            <div className="flex gap-3 pt-2">
              <Button
                variant="outline"
                className="flex-1 rounded-lg h-10"
                onClick={() => toast.info('Share receipt is not yet implemented')}
              >
                <Share2 className="h-4 w-4 mr-2" />
                Share
              </Button>
              <Button
                variant="action"
                className="flex-1 rounded-lg h-10"
                onClick={() => toast.info('Download receipt is not yet implemented')}
              >
                <Download className="h-4 w-4 mr-2" />
                Download
              </Button>
            </div>
          </div>
        </SheetFrame>
      </SheetContent>
    </Sheet>
  );
}
